// import React, { useEffect, useState } from "react";
// import { CircularProgress, Box } from "@mui/material";
// import dayjs from "dayjs";
// import api from "../../api/api";

// const EmployeeModal = ({ employee, dateRange, onClose }) => {
//   const [loading, setLoading] = useState(false);
//   const [recap, setRecap] = useState([]);
//   const [absentDates, setAbsentDates] = useState([]);
//   const [ptoDates, setPtoDates] = useState([]);
//   const practiseid = window.getPracticeId();

//   useEffect(() => {
//     if (employee && dateRange) {
//       fetchRecapData();
//     }
//   }, [employee, dateRange]);

// const fetchRecapData = async () => {
//   try {
//     setLoading(true);
//     const startDate = dateRange.startDate.format("YYYY-MM-DD");
//     const endDate = dateRange.endDate.format("YYYY-MM-DD");
// console.log(employee,'emp')
//     const response = await api.get(`/v1/${practiseid}/timesheet/recap`, {
//       params: {
//         start_date: startDate,
//         end_date: endDate,
//         emp_id: employee.id,
//       },
//     });

//     if (response.status === 200 && response.data?.length) {
//       const empData = response.data[0];
// console.log(empData,'emp')
//       if (empData) {
//         setRecap(empData.recap || []);
//         setAbsentDates(empData.absent_dates || []);

//         // ✅ Extract PTO date ranges
//         const ptoRanges =
//           empData.pto_details?.map((p) => ({
//             start: dayjs(p.start_date),
//             end: dayjs(p.end_date),
//           })) || [];
// console.log(ptoRanges,'ptoooo')
//         setPtoDates(ptoRanges);
//       }
//     } else {
//       setRecap([]);
//       setAbsentDates([]);
//       setPtoDates([]);
//     }
//   } catch (err) {
//     console.error("Error fetching employee recap:", err);
//     setRecap([]);
//     setAbsentDates([]);
//     setPtoDates([]);
//   } finally {
//     setLoading(false);
//   }
// };

//   if (!employee) return null;

//   // Generate all days in range
//   const start = dayjs(dateRange.startDate);
//   const end = dayjs(dateRange.endDate);
//   const daysInRange = [];
//   for (let d = start; d.isBefore(end) || d.isSame(end, "day"); d = d.add(1, "day")) {
//     daysInRange.push(d.format("YYYY-MM-DD"));
//   }

//   // Group by week (Sunday → Saturday)
//   const weeks = [];
//   let currentWeek = [];
//   daysInRange.forEach((date) => {
//     const weekday = dayjs(date).day(); // 0 = Sunday, 6 = Saturday
//     if (currentWeek.length === 0 && weekday !== 0) {
//       for (let i = 0; i < weekday; i++) currentWeek.push(null);
//     }
//     currentWeek.push(date);

//     if (weekday === 6) {
//       weeks.push(currentWeek);
//       currentWeek = [];
//     }
//   });
//   if (currentWeek.length > 0) weeks.push(currentWeek);

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//       <div className="bg-white w-[950px] max-h-[90vh] rounded-lg shadow-lg overflow-hidden flex flex-col">
//         {/* Header */}
//         <div className="flex justify-between text-start items-center border-b px-5 py-3 flex-shrink-0">
//           <div>
//             <h2 className="text-lg font-semibold text-gray-900">{employee.name}</h2>
//             <p className="text-sm text-gray-500">{employee.role}</p>
//           </div>
//           <button
//             onClick={onClose}
//             className="text-gray-400 hover:text-gray-700 text-2xl font-light"
//           >
//             ×
//           </button>
//         </div>

//         {/* Scrollable content */}
//         <div className="p-5 overflow-y-auto flex-grow">
//           {loading ? (
//             <Box display="flex" justifyContent="center" alignItems="center" height="250px">
//               <CircularProgress size={45} thickness={4} color="primary" />
//             </Box>
//           ) : (
//             <div className="border border-gray-300 rounded-md overflow-hidden">
//               {/* Header row with empty first cell */}
//               <div className="grid grid-cols-8 text-center text-white text-sm font-medium bg-[#50869A]">
//                 <div className="py-2"></div>
//                 <div className="py-2">Sun</div>
//                 <div className="py-2">Mon</div>
//                 <div className="py-2">Tue</div>
//                 <div className="py-2">Wed</div>
//                 <div className="py-2">Thu</div>
//                 <div className="py-2">Fri</div>
//                 <div className="py-2">Sat</div>
//               </div>

//               {/* Weeks */}
//               {weeks.map((weekDates, index) => {
//                 const validDates = weekDates.filter(Boolean);
//                 const weekStart = validDates[0] ? dayjs(validDates[0]).format("MMM D") : "";
//                 const weekEnd =
//                   validDates.length > 0
//                     ? dayjs(validDates[validDates.length - 1]).format("MMM D")
//                     : "";
//                 const weekLabel = `${weekStart} - ${weekEnd}`;

//                 return (
//                   <div key={index} className="grid grid-cols-8 border-t border-gray-300 text-center">
//                     {/* Week label column */}
//                     <div className="py-3 font-medium text-gray-700 border-r border-gray-300 bg-gray-50 sticky left-0">
//                       {weekLabel}
//                     </div>

//                 {Array.from({ length: 7 }).map((_, i) => {
//   const date = weekDates[i];
//   const displayDay = date ? dayjs(date).date() : "";
//   const isAbsent = date && absentDates.includes(date);

//   // ✅ Check if date falls within any PTO range
// const isPTO =
//   date &&
//   ptoDates.some((r) =>
//     dayjs(date).isSame(r.start, "day") ||
//     dayjs(date).isSame(r.end, "day") ||
//     (dayjs(date).isAfter(r.start, "day") && dayjs(date).isBefore(r.end, "day"))
//   );


//   return (
//     <div
//       key={i}
//       className={`py-4 border-r border-b border-gray-300 ${
//         isPTO
//           ? "bg-[#FFEDD5]" // PTO background (light orange)
//           : isAbsent
//           ? "bg-[#FFE8E1]" // Absent background (light red)
//           : "bg-white"
//       }`}
//     >
//       {displayDay && (
//         <>
//           <div className="text-gray-900 font-medium">{displayDay}</div>

//           {/* ✅ Show PTO tag only when date is in PTO range */}
//           {isPTO && (
//             <div className="text-xs text-[#EA580C] font-semibold mt-1">
//               PTO
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// })}

//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmployeeModal;



import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
import dayjs from "dayjs";
import api from "../../api/api";
import jsPDF from "jspdf";
// import "jspdf-autotable";

const EmployeeModal = ({ employee, dateRange, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [recap, setRecap] = useState([]);
  const [absentDates, setAbsentDates] = useState([]);
  const [ptoDates, setPtoDates] = useState([]);
  const [view, setView] = useState("table"); // toggle: 'calendar' | 'table'
  const practiseid = window.getPracticeId();

  // Fetch data on employee or dateRange change
  useEffect(() => {
    if (employee && dateRange) {
      fetchRecapData();
    }
  }, [employee, dateRange]);

  const fetchRecapData = async () => {
    try {
      setLoading(true);
      const startDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
      const endDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");

      const response = await api.get(`/v1/${practiseid}/timesheet/recap`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          emp_id: employee.id,
        },
      });

      if (response.status === 200 && response.data?.length) {
        const empData = response.data[0];
        setRecap(empData.recap || []);
        setAbsentDates(empData.absent_dates || []);
        const ptoRanges =
          empData.pto_details?.map((p) => ({
            start: dayjs(p.start_date),
            end: dayjs(p.end_date),
          })) || [];
        setPtoDates(ptoRanges);
      } else {
        setRecap([]);
        setAbsentDates([]);
        setPtoDates([]);
      }
    } catch (err) {
      console.error("Error fetching employee recap:", err);
      setRecap([]);
      setAbsentDates([]);
      setPtoDates([]);
    } finally {
      setLoading(false);
    }
  };

  if (!employee) return null;

  // --- Calendar logic ---
  const start = dayjs(dateRange.startDate);
  const end = dayjs(dateRange.endDate);
  const daysInRange = [];
  for (let d = start; d.isBefore(end) || d.isSame(end, "day"); d = d.add(1, "day")) {
    daysInRange.push(d.format("YYYY-MM-DD"));
  }

  const weeks = [];
  let currentWeek = [];
  daysInRange.forEach((date) => {
    const weekday = dayjs(date).day();
    if (currentWeek.length === 0 && weekday !== 0) {
      for (let i = 0; i < weekday; i++) currentWeek.push(null);
    }
    currentWeek.push(date);
    if (weekday === 6) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  });
  if (currentWeek.length > 0) weeks.push(currentWeek);









const generatePDF = (employee, recap) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const startX = 14;
  let startY = 20;

  // Title
  doc.setFontSize(16);
  doc.text(`${employee.name} Timesheet`, pageWidth / 2, startY, { align: "center" });
  startY += 10;

  // Table Header
  const headers = [ "Date", "Clock In", "Clock Out", "Total Hours"];
  doc.setFontSize(10);
  let x = startX;
  headers.forEach((header, i) => {
    doc.text(header, x, startY);
    x += 45; // adjust column width
  });
  startY += 6;

  // Draw a line below header
  doc.line(startX, startY, pageWidth - startX, startY);
  startY += 4;

  // Table rows
recap.forEach((day) => {
  const dateStr = `${dayjs(day.date).format("YYYY-MM-DD")} (${dayjs(day.date).format("ddd")})`;

  // ✅ Loop through entries (same as table view)
  day.entries?.forEach((entry) => {
    let x = startX;

    const clockIn = entry.clock_in_time
      ? dayjs(`2000-01-01 ${entry.clock_in_time}`).format("HH:mm")
      : "-";

    const clockOut = entry.clock_out_time
      ? dayjs(`2000-01-01 ${entry.clock_out_time}`).format("HH:mm")
      : "-";

    // ✅ Format total_hours same as table
    const formatHours = (timeStr) => {
      if (!timeStr) return "-";
      const [h = 0, m = 0] = timeStr.split(":").map(Number);
      if (h === 0 && m === 0) return "0:00";
      if (h === 0) return `0:${String(m).padStart(2, "0")}`;
      if (m === 0) return `${h}:00`;
      return `${h}:${String(m).padStart(2, "0")}`;
    };

// const formatHours = (timeStr) => {
//   if (!timeStr) return "-";
//   const [h = 0, m = 0] = timeStr.split(":").map(Number);
//   return `${h}:${String(m).padStart(2, "0")}`;
// };

    const row = [
      dateStr,
      clockIn,
      clockOut,
      formatHours(day.total_hours),
    ];

    row.forEach((cell) => {
      doc.text(String(cell), x, startY);
      x += 45; // ✅ wider columns to fit date with day name
    });

    startY += 6;

    if (startY > 280) {
      doc.addPage();
      startY = 20;
    }
  });
});

// ✅ Grand Total in PDF
let totalSeconds = 0;
recap.forEach((day) => {
  const [h = 0, m = 0, s = 0] = (day.total_hours || "0:00:00").split(":").map(Number);
  totalSeconds += h * 3600 + m * 60 + s;
});
const totalHrs = Math.floor(totalSeconds / 3600);
const totalMins = Math.floor((totalSeconds % 3600) / 60);
const grandTotal = `${totalHrs}:${String(totalMins).padStart(2, "0")}`;

doc.line(startX, startY, pageWidth - startX, startY);
startY += 6;
doc.setFontSize(11);
doc.text("Grand Total:", startX, startY);
doc.text(grandTotal, startX + 135, startY);
  

  doc.save(`${employee.name.replace(" ", "_")}_Timesheet.pdf`);
};




  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white w-[950px] max-h-[90vh] rounded-lg shadow-lg overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-5 py-3 flex-shrink-0">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">{employee.name}</h2>
            <p className="text-sm text-gray-500">{employee.role}</p>
          </div>
          <div className="flex items-center gap-2">
            {/* <button
              onClick={() => setView("calendar")}
              className={`px-3 py-1 rounded ${
                view === "calendar" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"
              }`}
            >
              Calendar
            </button> */}
            {/* <button
              onClick={() => setView("table")}
              className={`px-3 py-1 rounded ${
                view === "table" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"
              }`}
            >
              Table
            </button> */}
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-700 text-2xl font-light ml-3"
            >
              ×
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="p-3 overflow-y-auto flex-grow">
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="250px">
              <CircularProgress size={45} thickness={4} color="primary" />
            </Box>
          ) : view === "calendar" ? (
            <div className="border border-gray-300 rounded-md overflow-hidden">
              {/* Calendar Header */}
              <div className="grid grid-cols-8 text-center text-white text-sm font-medium bg-[#50869A]">
                <div className="py-2"></div>
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                  <div key={day} className="py-2">
                    {day}
                  </div>
                ))}
              </div>

              {/* Weeks */}
              {weeks.map((weekDates, index) => {
                const validDates = weekDates.filter(Boolean);
                const weekStart = validDates[0] ? dayjs(validDates[0]).format("MMM D") : "";
                const weekEnd =
                  validDates.length > 0
                    ? dayjs(validDates[validDates.length - 1]).format("MMM D")
                    : "";
                const weekLabel = `${weekStart} - ${weekEnd}`;

                return (
                  <div key={index} className="grid grid-cols-8 border-t border-gray-300 text-center">
                    <div className="py-3 font-medium text-gray-700 border-r border-gray-300 bg-gray-50 sticky left-0">
                      {weekLabel}
                    </div>
                    {Array.from({ length: 7 }).map((_, i) => {
                      const date = weekDates[i];
                      const displayDay = date ? dayjs(date).date() : "";
                      const isAbsent = date && absentDates.includes(date);
                      const isPTO =
                        date &&
                        ptoDates.some(
                          (r) =>
                            dayjs(date).isSame(r.start, "day") ||
                            dayjs(date).isSame(r.end, "day") ||
                            (dayjs(date).isAfter(r.start, "day") &&
                              dayjs(date).isBefore(r.end, "day"))
                        );
                      return (
                        <div
                          key={i}
                          className={`py-4 border-r border-b border-gray-300 ${
                            isPTO
                              ? "bg-[#FFEDD5]"
                              : isAbsent
                              ? "bg-[#FFE8E1]"
                              : "bg-white"
                          }`}
                        >
                          {displayDay && (
                            <>
                              <div className="text-gray-900 font-medium">{displayDay}</div>
                              {isPTO && (
                                <div className="text-xs text-[#EA580C] font-semibold mt-1">
                                  PTO
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          ) : (
            // --- Table View ---
            <div className="mt-2">
             <div className="flex justify-between"> 
              <h6 className="text-gray-700 font-semibold mb-2">Timesheet Details</h6>

              <button
                onClick={() => generatePDF(employee, recap)}
                className="px-3 py-1 mb-1 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Download PDF
              </button>
          </div>

              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead className="bg-gray-200">
                      <tr>
                        <th colSpan={6} className="px-3 py-2 text-left text-gray-700">
                        Employee :  {employee.name} (ID: {employee.id})
                        </th>
                      </tr>
                    <tr>
                      <th className="px-3 py-2 border-b">Date</th>
                      <th className="px-3 py-2 border-b">Clock In</th>
                      <th className="px-3 py-2 border-b">Clock Out</th>
                      <th className="px-3 py-2 border-b">Total Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recap.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="text-center py-4 text-gray-500">
                          No timesheet data available
                        </td>
                      </tr>
                    ) : (
                          recap.map((day, idx) => {

                             const firstEntry = day.entries?.[0];

                            // get last clock-out (important if multiple punches)
                            const lastEntry = day.entries?.[day.entries.length - 1];

                            // ✅ Format total_hours from "HH:MM:SS" → "H hrs M mins"
                            const formatHours = (timeStr) => {
                              if (!timeStr) return "-";
                              const [h = 0, m = 0] = timeStr.split(":").map(Number);
                              if (h === 0 && m === 0) return "0";
                              if (h === 0) return `${m}`;
                              if (m === 0) return `${h}`;
                              return `${h}:${String(m).padStart(2, "0")}`;
                            };

                            return day.entries.map((entry, eIdx) => (
                              <tr key={`${idx}-${eIdx}`} className="text-center">
                                <td className="px-3 py-2 border-b text-start">
                                 {`${dayjs(day.date).format("YYYY-MM-DD")} (${dayjs(day.date).format("dddd")})`}
                                </td>
<td className="px-3 py-2 border-b">
  {firstEntry.clock_in_time
    ? dayjs(`2000-01-01 ${entry.clock_in_time}`).format("HH:mm")
    : "-"}
</td>
<td className="px-3 py-2 border-b">
  {lastEntry.clock_out_time
    ? dayjs(`2000-01-01 ${entry.clock_out_time}`).format("HH:mm")
    : "-"}
</td>
                                {/* ✅ Use day.total_hours (same as RecapTable) */}
                                <td className="px-3 py-2 border-b font-medium text-gray-800">
                                  {formatHours(day.total_hours)}
                                </td>
                              </tr>
                            ));
                          })
                    )}
                    {/* ✅ Grand Total Row — same calculation as RecapTable */}
{recap.length > 0 && (() => {
  let totalSeconds = 0;
  recap.forEach((day) => {
    const [h = 0, m = 0, s = 0] = (day.total_hours || "0:00:00")
      .split(":")
      .map(Number);
    totalSeconds += h * 3600 + m * 60 + s;
  });
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const display =
    hours === 0
      ? `${minutes}`
      : minutes === 0
      ? `${hours}`
      : `${hours}:${minutes} `;

  return (
    <tr className="bg-gray-100 font-semibold text-center">
      <td className="px-3 py-2 border-t text-right" colSpan={3}>
        Grand Total
      </td>
      <td className="px-3 py-2 border-t text-[#50869A]">
        {display}
      </td>
    </tr>
  );
})()}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeModal;